import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export default function UrgentBanner() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        let cancel = false;
        const load = () => api.get("/comunicaciones/avisos-urgentes")
            .then((r) => { if (!cancel) setItems(r.data || []); })
            .catch(() => {});
        load();
        const id = setInterval(load, 60_000);
        return () => { cancel = true; clearInterval(id); };
    }, []);
    if (!items.length) return null;
    return (
        <div data-testid="urgent-banner" className="bg-destructive text-destructive-foreground px-4 py-2 flex items-start gap-3 sticky top-0 z-40">
            <AlertTriangle className="h-5 w-5 mt-0.5 shrink-0" />
            <div className="flex-1 text-sm">
                <strong className="font-semibold">{items[0].titulo}: </strong>
                <span>{items[0].mensaje}</span>
                {items.length > 1 && (
                    <span className="ml-2 opacity-80">(+{items.length - 1} más)</span>
                )}
            </div>
        </div>
    );
}
